import Vue from 'vue'
import VtRichTextEditor from '@/components/common/VtRichTextEditor.vue'
Vue.component('VtRichTextEditor', VtRichTextEditor)
